import { type ReactNode, Suspense } from 'react';
import { SectionErrorBoundary } from './ErrorBoundary';

type OwnProps = {
  children: ReactNode;
  fallback?: ReactNode;
  section: string;
};

// An async server section: streams behind Suspense, and a failure hides only this section.
export default function StreamedSection({
  children,
  fallback = null,
  section
}: OwnProps) {
  return (
    <SectionErrorBoundary section={section}>
      <Suspense fallback={fallback}>{children}</Suspense>
    </SectionErrorBoundary>
  );
}
